import React, { Suspense } from "react";
import Loader from "../components/Loader";

const LazyRoute = ({ component: Component, ...rest }) => (
  <Suspense fallback={<Loader pastDelay timedOut />}>
    <Component {...rest} />
  </Suspense>
);

export default LazyRoute;
